var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvasRef",staticClass:"canvas_contents"},[_c('canvas',{attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }